// extracted by mini-css-extract-plugin
module.exports = {"root":"OrganicAboutSection_root__2j8fN","content":"OrganicAboutSection_content__tb7o8","text":"OrganicAboutSection_text__RKe6_"};